import React from "react";
import { StyleSheet } from "react-native";
import Text from "@components/CustomText";
import BottomSheet from "@components/ds/BottomSheet";
import SheetButtons from "@components/ds/SheetButtons";
import { tokens } from "../styles";

// Confirm-unassign-all sheet for a single DB. Mirrors the prototype's
// destructive confirm look — red primary + neutral cancel.

const UnassignSheet = ({
  visible,
  db,
  count,
  onClose,
  onConfirm,
  submitting,
}) => (
  <BottomSheet
    visible={visible}
    title={`Unassign all from ${db?.db_name || "DB"}?`}
    onClose={onClose}
    footer={
      <SheetButtons
        onCancel={onClose}
        onConfirm={onConfirm}
        loading={submitting}
        destructive
        confirmLabel="Unassign All"
      />
    }
  >
    <Text variant="caption_2" style={styles.body}>
      This will remove{" "}
      <Text variant="caption_2" style={styles.strong}>
        {count}
      </Text>{" "}
      customers from this DB. The customers will become unassigned and need a
      new bundle.
    </Text>
  </BottomSheet>
);

export default UnassignSheet;

const styles = StyleSheet.create({
  body: { color: tokens.textPrimary, fontSize: 13 },
  strong: { color: tokens.textPrimary, fontWeight: "700" },
});
